import { render } from "./resignation-notice.vue?vue&type=template&id=4edf01cc"
import script from "./resignation-notice.vue?vue&type=script&lang=js"
export * from "./resignation-notice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__